export default __webpack_public_path__ + "static/media/BLR12.e48aed48.jpg";